export let GITSHA = '90527c0';